(() => {
  const mount = (container = document) => {
    container.querySelectorAll('[data-sg-flower-colour]').forEach(root => {
      if (root.dataset.sgFlowerReady === 'true') return;
      root.dataset.sgFlowerReady = 'true';
      const scope = root.closest('.shopify-section') || document;
      const choices = Array.from(root.querySelectorAll('[data-sg-flower-option]'));
      const propertySelector = '[data-sg-flower-property][data-sg-flower-product="' + root.dataset.productId + '"]';
      const selectedLabel = root.querySelector('[data-sg-flower-selected]');
      let retryTimer;
      let resizeFrame;
      const selected = () => choices.find(choice => choice.checked && !choice.disabled) || choices.find(choice => !choice.disabled);
      const syncChoices = (preferred) => {
        const height = scope.querySelector('[data-sg-native-height].is-active')?.dataset.sgNativeHeight || root.dataset.defaultHeight;
        const current = preferred || choices.find(choice => choice.checked)?.value;
        choices.forEach(choice => {
          const available = !choice.dataset.height || choice.dataset.height === height;
          choice.disabled = !available;
          choice.closest('label').hidden = !available;
        });
        const next = choices.find(choice => !choice.disabled && choice.value === current) || choices.find(choice => !choice.disabled);
        choices.forEach(choice => { choice.checked = choice === next; });
      };
      const syncUrl = () => {
        const choice = selected();
        if (!choice) return;
        const url = new URL(window.location.href);
        url.searchParams.set('flower_colour', choice.value);
        window.history.replaceState(window.history.state, '', url);
      };
      const syncProperties = () => {
        const choice = selected();
        if (!choice) return;
        scope.querySelectorAll(propertySelector).forEach(input => { input.value = choice.value; });
        if (selectedLabel) selectedLabel.textContent = choice.value;
      };
      const showMedia = (attempt = 0) => {
        const choice = selected();
        if (!choice || !root.isConnected) return;
        let waitingForCarousel = false;
        scope.querySelectorAll('.product__media-container').forEach(gallery => {
          const target = gallery.querySelector('[data-media-item-id="' + choice.dataset.mediaId + '"]');
          if (!target) return;
          if (gallery.dataset.galleryStyle === 'carousel') {
            const swiper = gallery.swiper;
            if (!swiper || swiper.destroyed) {
              if (gallery.getClientRects().length && getComputedStyle(gallery).display !== 'none') waitingForCarousel = true;
              return;
            }
            const index = Number(target.dataset.slideIndex);
            if (!Number.isFinite(index)) return;
            if (swiper.params.loop && typeof swiper.slideToLoop === 'function') swiper.slideToLoop(index, 0);
            else swiper.slideTo(index, 0);
          } else if (gallery.dataset.galleryStyle === 'thumbnails') {
            const thumbnail = gallery.querySelector('[data-product-thumbnail][data-thumbnail-id="' + choice.dataset.mediaId + '"]');
            if (thumbnail) thumbnail.click();
            gallery.querySelectorAll('[data-product-media-wrapper]').forEach(media => {
              media.classList.toggle('hidden', media !== target);
            });
            gallery.querySelectorAll('[data-product-thumbnail]').forEach(button => {
              button.classList.toggle('active', button.dataset.thumbnailId === choice.dataset.mediaId);
            });
          }
        });
        clearTimeout(retryTimer);
        if (waitingForCarousel && attempt < 15) retryTimer = setTimeout(() => showMedia(attempt + 1), 120);
      };
      const requested = new URL(window.location.href).searchParams.get('flower_colour');
      syncChoices(requested);
      syncProperties();
      requestAnimationFrame(() => showMedia());
      root.addEventListener('change', event => {
        if (!event.target.matches('[data-sg-flower-option]')) return;
        syncProperties();
        showMedia();
        syncUrl();
      });
      scope.addEventListener('change', event => {
        if (root.contains(event.target) || event.target.matches('[data-sg-flower-property]')) return;
        requestAnimationFrame(() => { syncChoices(); syncProperties(); showMedia(); syncUrl(); });
      });
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => showMedia());
      });
      window.addEventListener('pageshow', () => { syncChoices(); syncProperties(); showMedia(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

